import { render, staticRenderFns } from "./_articleId.vue?vue&type=template&id=2f127892&"
import script from "./_articleId.vue?vue&type=script&lang=js&"
export * from "./_articleId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports